import { ChangeEventHandler } from 'react';

export default function LevelInput({ value, activeLevel, handler }:any) {

  // create a function which takes string, capitalize first character, convert underscores to spaces, replace hyphens with spaces
function unslugify(str: string) {
  return str
    .replace(/_/g, ' ') // convert underscores to spaces
    .replace(/-/g, ' ') // convert hyphens to spaces
    .replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    }); // capitalize first character
}

  return (
    <label
      className="relative flex cursor-pointer justify-between border-b border-[#f0f2f3] py-[0.68rem]
			last:border-b-0 [&_span:after]:hover:bg-[#f0f2f3] text-secondary"
    >
      <input
        checked={value === activeLevel}
        className="hidden [&+span]:checked:after:border-[6px] [&+span]:checked:after:border-primary"
        name="level"
        type="radio"
        value={value}
        onChange={handler}
      />
      <span
        className="text-[0.9375rem]	after:absolute after:right-0 after:top-1/2 after:h-5 after:w-5 after:-translate-y-1/2
				after:rounded-full after:border after:border-[#c5c7ca] after:bg-white"
      >
        {unslugify(value)}
      </span>
    </label>
  );
}
